import React from 'react'
import MembershipCard from './MembershipCard'
import AvailableContent from './AvailableContent'

const Manage = ({
  teamData = []
}) => {

  return (
    <>
      <MembershipCard teamData={ teamData } />
      {/* <AvailableContent/> */}
    </>
  )

}

export default Manage
